/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './RecommendationCarouselSkeleton.scss';

import { Placeholder, PlaceholderText, ContentBlock } from 'sarsaparilla';

function PlaceholderCard() {
    return (
        <>
            <Placeholder
                className="mb-half"
                height="100%"
                style={{ aspectRatio: '1.5/1' }}
                borderRadius="8px"
            />
            <PlaceholderText lines={3} fontSize={14} lineHeight={24} />
        </>
    );
}

export function RecommendationCarouselSkeleton() {
    return (
        <div className="nav--recommendation-carousel-skeleton">
            <ContentBlock>
                <div className="mb-2">
                    <PlaceholderText
                        lines={1}
                        fontSize={30}
                        lineHeight={34}
                        width="210px"
                    />
                </div>

                <PlaceholderText lines={1} width="300px" lineHeight={28} />
            </ContentBlock>

            <div className="carousel mt-2">
                <div className="carousel-items">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div className="carousel-item" key={index}>
                            <PlaceholderCard />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
